module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAdVBMVEUAAADdFyvdFizdFizkFC/dFC/dFyz/0TPqYS6kFRfyti/lmyv+zzL1vC/ahCfIXSHzuC/ilCndiSjUeCXPbCO1OR6tJx2pHhj6xzHxtC7trC3IXyfATh+vLBr856z/3Wn3wDDxtS/rpiznoSzmnSvQcCW5QR7AVft9AAAABnRSTlMA8K6tJiZLVfEQAAAArUlEQVRIx+3VVw7CQAxF0ZmUcV4yJb2HDvtfImIHthACodz/82c9qz1WaawNMx2nSiXaCNKJioyoSGkZ0MoI+wuQCVMk7B3gAbQSEAA82MB7GmtfO6oaywEOcDRVM9GAKwfkQN5sS7cQUDDBeTgdD73jgwmvZj7I0SL0pQB0RX8ZLBOUQFltbdcQcOMAG4KlYq2J7usovqVvg0zYL47Ax4F4jMVzL34o4pe1x+kJT2cvujdspKoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/es@2x.png
// module id = 8ySj
// module chunks = 0